import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getChecklistAfterSeasonAvailableColumns } from './api';

export const path = '/checklist/after/season/list';

const PageChecklistAfterSeason: React.FC = (props) => {
  const ChecklistAfterSeason = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getChecklistAfterSeasonAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ChecklistAfterSeason {...props} />;
};

export default PageChecklistAfterSeason;
